export const defaultConfig = {
  restaurant_id: "auto_generated_id",

  general: {
    name: "Restaurant Name",
    logo: "",
    contact_number: "",
    city: "",
    address: "",
    description: ""
  },

  customer_data: {
    ask_name: true,
    ask_phone: true,
    ask_table_confirmation: true,
    guest_checkout: true,
    require_login: false
  },

  ordering: {
    accept_orders: true,
    auto_accept: true,
    service_type: "dine_in",
    estimated_prep_time: true,
    enable_live_status: true,
    enable_repeat_order: true,
    enable_split_bill: false
  },

  customization: {
    menu_layout: {
      type: "swiggy_cards",
      available_layouts: [
        "swiggy_cards",
        "zomato_compact",
        "grid",
        "list",
        "pdf_style"
      ],
      card_style: {
        image_position: "right",
        image_size: "medium",
        border_radius: "rounded",
        shadow: true,
        spacing: "comfortable"
      },
      density: {
        items_per_row: 1,
        compact_mode: false
      }
    },
    menu_flow: {
      show_best_sellers_first: true,
      show_categories_first: false,
      enable_recommendations: true,
      enable_recent_orders: true
    },
    menu_sections: {
      show_offers: true,
      offers_style: "chips",
      show_search: true,
      show_veg_toggle: true,
      show_category_tabs: true,
      sticky_categories: true,
      sticky_header: true
    },
    item_card: {
      show_image: true,
      show_description: true,
      show_rating: false,
      show_tags: true,
      show_veg_badge: true,
      show_prep_time: false,
      tags: [
        "Bestseller",
        "Chef Special",
        "New",
        "Spicy",
        "Healthy"
      ]
    },
    pricing: {
      show_strike_price: true,
      show_discount_badge: true
    },
    add_to_cart: {
      button_style: "full_width",
      default_text: "Add",
      after_add_behavior: "stepper",
      show_quantity_controls: true
    },
    cart: {
      sticky: true,
      show_item_count: true,
      show_total_price: true,
      show_savings_progress: true,
      enable_cart_genie: true,
      messages: [
        "You're ₹{remaining} away from {offer} OFF 🎉",
        "Coupon auto-applied"
      ]
    },
    upselling: {
      enabled: true,
      trigger: "on_add",
      types: [
        "frequently_bought",
        "combos",
        "addons"
      ],
      max_items: 3
    },
    theme: {
      primary_color: "#f9d81a",
      secondary_color: "#1c1a0d",
      font_style: "modern",
      button_style: "rounded",
      dark_mode: false
    },
    pdf_mode: {
      enabled: false,
      layout: "single_column",
      font_size: "medium",
      download_enabled: true
    }
  },

  engagement: {
    show_call_waiter: true,
    enable_feedback: true,
    enable_notifications: true
  }
};
